import React from "react";
import moment from "moment";
//import { Link } from "react-router-dom";
import styles from "./style";
import { connect } from "react-redux";
import { css } from "aphrodite";
//import axios from 'axios';
import { Navbar, Container, Nav, Button, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { withRouter, Link } from "react-router-dom";
import PhoneWatchIcon from "../../Icons/PhoneWatchIcon";

class Header extends React.Component {
    constructor(props) {
        super();
        this.state = {
            isOpen: false,
            entityLogo: "",
            patientData: {},
        };
    }

    toggle = () => {
        const { isOpen } = this.state;
        this.setState({ isOpen: !isOpen });
    };

    logout = () => {
        this.props.history.push("/logout");
    };

    logout = () => {
        this.props.history.push("/logout");
    };

    renderSubscriptionContent = () => {
        const { patientSubscription } = this.props;

        if (!patientSubscription) {
            return <div>{"No Available Subscription"}</div>;
        }

        const dateLabel =
            patientSubscription?.status === 4
                ? "Cancellation Date"
                : "Renewal Due Date";
        const dateValue =
            patientSubscription?.status === 4
                ? moment(patientSubscription?.canceledAt).format("MMM Do, YYYY")
                : moment(patientSubscription?.nextDueDate).format("MMM Do, YYYY");

        return (
            <>
                <div className={css(styles.subsPlanName)}>
                    {patientSubscription?.subscriptionPlan?.planName}
                </div>
                <div className={css(styles.subsDateLine)}>
                    {`${dateLabel}: ${dateValue}`}
                </div>
                <span
                    className={css(styles.circle)}
                    style={
                        patientSubscription?.status === 1 ||
                        patientSubscription?.status === 5
                            ? { background: "#10ff10" }
                            : { background: "#f93d3d" }
                    }
                />
            </>
        );
    };

    renderSubscriptionPill = (compact = false) => {
        const { user } = this.props;

        if (!user.isSubscriptionApplicable) {
            return null;
        }

        return (
            <div
                className={`${compact ? "d-none d-sm-flex align-items-center" : ""} ${css(
                    compact ? styles.subsWrapperCompact : styles.subsWrapper1
                )}`}
            >
                <div className={`header-subs-pill ${css(styles.subsWrapper2)}`}>
                    {this.renderSubscriptionContent()}
                </div>
            </div>
        );
    };

    renderProfileDropdown = () => {
        const { user } = this.props;
        const isCaregiver = user?.roleId === 10;
        const displayName = isCaregiver
            ? `${user?.caregiver?.firstName || ""} ${user?.caregiver?.lastName || ""} (view-only)`
            : `${this.props.profileData?.patientData?.firstName || ""} ${this.props.profileData?.patientData?.lastName || ""}`;
        const displayRole = isCaregiver ? "Caregiver" : (user?.roleName || "");

        return (
            <Dropdown align="end" className="header-compact-profile">
                <Dropdown.Toggle
                    as={Button}
                    variant="link"
                    className={css(styles.profileToggle)}
                    id="header-profile-dropdown"
                >
                    <img
                        alt="avatar"
                        src="/images/user-flat.png"
                        className={css(styles.avatarCompact)}
                    />
                </Dropdown.Toggle>
                <Dropdown.Menu className="header-profile-menu shadow">
                    <div className="header-profile-menu-header">
                        <img
                            alt="avatar"
                            src="/images/user-flat.png"
                            className="header-profile-menu-avatar"
                        />
                        <div>
                            <div className="header-profile-name">{displayName}</div>
                            {displayRole ? (
                                <div className="header-profile-role">{displayRole}</div>
                            ) : null}
                        </div>
                    </div>
                    {user.isSubscriptionApplicable && (
                        <div className="header-mobile-subscription d-block d-sm-none">
                            <div className="header-mobile-subscription-label">Subscription</div>
                            <div className={`header-subs-pill ${css(styles.subsWrapper2)} ${css(styles.subsWrapperDropdown)}`}>
                                {this.renderSubscriptionContent()}
                            </div>
                        </div>
                    )}
                    <Dropdown.Divider className="header-profile-divider" />
                    <Dropdown.Item
                        onClick={this.logout}
                        className="header-profile-logout"
                    >
                        <FontAwesomeIcon
                            icon={faRightFromBracket}
                            className="header-profile-logout-icon"
                        />
                        Logout
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    render() {
        const { user, patientSubscription } = this.props;
        // Define if user is a caregiver
        const isCaregiver = user?.roleId === 10;
        const hasActiveSubscription =
            !user?.isSubscriptionApplicable ||
            patientSubscription?.status === 1 ||
            patientSubscription?.status === 5;

        // Determine display name and role
        const displayName = isCaregiver
            ? `${user?.caregiver?.firstName || ""} ${user?.caregiver?.lastName || ""} (view-only)`
            : `${this.props.profileData?.patientData?.firstName || ""} ${this.props.profileData?.patientData?.lastName || ""}`;

        const displayRole = isCaregiver ? "Caregiver" : (user?.roleName || "");

        return (
            <div>
                <style>{`
                    .dashboard-wrapper--blurred {
                        filter: blur(5px) brightness(0.4);
                        transition: filter 0.2s ease-in-out;
                        pointer-events: none;
                    }
                    .patient-header-navbar .header-container {
                        align-items: center;
                        flex-wrap: nowrap;
                    }
                    .patient-header-navbar .header-desktop-nav {
                        gap: 0;
                    }
                    .patient-header-navbar .header-compact-nav {
                        gap: 8px;
                        flex-shrink: 0;
                    }
                    @media (max-width: 575.98px) {
                        .patient-header-navbar .header-compact-nav {
                            gap: 4px;
                        }
                        .patient-header-navbar .header-compact-nav .nav {
                            gap: 0;
                        }
                        .patient-header-navbar .header-compact-nav a {
                            padding-right: 0.5rem !important;
                        }
                    }
                    .header-profile-menu {
                        min-width: 260px;
                        padding: 0;
                        border: none;
                        border-radius: 12px;
                        overflow: hidden;
                    }
                    .header-profile-menu-header {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        padding: 16px;
                        background: linear-gradient(135deg, #f8f9ff 0%, #eef4ff 100%);
                        border-bottom: 1px solid #e9ecef;
                    }
                    .header-profile-menu-avatar {
                        width: 44px;
                        height: 44px;
                        border-radius: 50%;
                        border: 2px solid #3f82da;
                        flex-shrink: 0;
                    }
                    .header-profile-name {
                        white-space: normal;
                        font-weight: 600;
                        font-size: 15px;
                        color: #212529;
                        line-height: 1.3;
                    }
                    .header-profile-role {
                        font-size: 13px;
                        color: #6c757d;
                        margin-top: 2px;
                    }
                    .header-mobile-subscription {
                        padding: 12px 16px 4px;
                    }
                    .header-mobile-subscription-label {
                        font-size: 11px;
                        font-weight: 600;
                        letter-spacing: 0.04em;
                        text-transform: uppercase;
                        color: #6c757d;
                        margin-bottom: 8px;
                    }
                    .header-profile-divider {
                        margin: 8px 0 0;
                    }
                    .header-profile-logout {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        padding: 12px 16px;
                        font-weight: 500;
                        color: #dc3545;
                    }
                    .header-profile-logout:hover,
                    .header-profile-logout:focus {
                        background-color: #fff5f5;
                        color: #bb2d3b;
                    }
                    .header-profile-logout-icon {
                        width: 16px;
                    }
                    .patient-header-navbar .header-compact-profile .dropdown-toggle::after {
                        display: none;
                    }
                    @media (min-width: 576px) and (max-width: 991.98px) {
                        .patient-header-navbar .header-compact-nav .header-subs-pill {
                            font-size: 11px;
                            padding: 6px 12px;
                            max-width: 200px;
                        }
                        .patient-header-navbar .navbar-brand img {
                            width: 200px;
                            padding-top: 0 !important;
                        }
                    }
                `}</style>
                <div className={(user?.entityMaster?.shortName === "SM" && this.props.patientSubscription === null) ? 'dashboard-wrapper--blurred' : ''}>
                    <Navbar
                        collapseOnSelect
                        expand="lg"
                        bg="dark"
                        variant="dark"
                        className={`patient-header-navbar ${css(styles.header)} ${css(styles.menu)}`}
                    >
                        <Container fluid className="header-container">
                            <Navbar.Brand className="d-flex align-items-center me-0">
                                <Button
                                    className={css(styles.toggleStyle)}
                                    variant="link"
                                    active={this.props.isOpen}
                                    onClick={this.props.toggle}
                                >
                                    <FontAwesomeIcon icon={faBars} />
                                </Button>
                                <Link
                                    to={
                                        user.roleId === 3
                                            ? "/entitydashboard"
                                            : "/dashboard"
                                    }
                                    className={css(styles.navLink)}
                                    title="Home"
                                >
                                    <img
                                        alt="logo"
                                        src="/images/inspyre_logo_new.png"
                                        className={css(styles.logoStyle)}
                                    />
                                </Link>
                            </Navbar.Brand>

                            <div className="header-compact-nav d-flex d-lg-none align-items-center ms-auto">
                                <Nav className="align-items-center flex-row">
                                    <Link
                                        to={
                                            user.roleId === 3
                                                ? "/entitydashboard"
                                                : "/dashboard"
                                        }
                                        className={css(styles.navLink)}
                                        title="Home"
                                    >
                                        <img
                                            className={css(styles.imageiconsMenu)}
                                            alt="home"
                                            src="/images/home.png"
                                        />
                                    </Link>
                                    {hasActiveSubscription && (
                                        <Link
                                            to={"/connected-device"}
                                            className={css(styles.navLink)}
                                            title="Connected Devices"
                                        >
                                            <PhoneWatchIcon
                                                className={css(styles.connectedDeviceIcon)}
                                                title="Connected Devices"
                                            />
                                        </Link>
                                    )}
                                    {!isCaregiver && (
                                        <Link to={"/faqs"} title="Help">
                                            <img
                                                className={css(styles.imageiconsMenu)}
                                                alt="help"
                                                src="/images/help_outline.png"
                                            />
                                        </Link>
                                    )}
                                </Nav>
                                {this.renderSubscriptionPill(true)}
                                {this.renderProfileDropdown()}
                            </div>

                            <div className="header-desktop-nav d-none d-lg-flex align-items-center ms-auto">
                                <Nav className="align-items-center">
                                    <Link
                                        to={
                                            user.roleId === 3
                                                ? "/entitydashboard"
                                                : "/dashboard"
                                        }
                                        className={css(styles.navLink)}
                                        title="Home"
                                    >
                                        <img
                                            className={css(styles.imageiconsMenu)}
                                            alt="home"
                                            src="/images/home.png"
                                        />
                                    </Link>
                                    {hasActiveSubscription && (
                                        <Link
                                            to={"/connected-device"}
                                            className={css(styles.navLink)}
                                            title="Connected Devices"
                                        >
                                            <PhoneWatchIcon
                                                className={css(styles.connectedDeviceIcon)}
                                                title="Connected Devices"
                                            />
                                        </Link>
                                    )}
                                    {!isCaregiver && (
                                        <Link to={"/faqs"} title="Help">
                                            <img
                                                className={css(styles.imageiconsMenu)}
                                                alt="help"
                                                src="/images/help_outline.png"
                                            />
                                        </Link>
                                    )}
                                </Nav>
                                <Nav className="align-items-center">
                                    {this.renderSubscriptionPill(false)}
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            paddingLeft: "1.2em",
                                        }}
                                    >
                                        <img
                                            alt="avatar"
                                            src="/images/user-flat.png"
                                            className={css(styles.avatar)}
                                        />
                                        <div className={css(styles.name)}>
                                            {displayName}
                                            <div className={css(styles.role)}>
                                                {displayRole}
                                            </div>
                                            <div className={css(styles.last)}>
                                                Last login:{" "}
                                                {moment(
                                                    this.props.user.lastLoggedIn
                                                ).format("MMM Do, YYYY, h:mm A")}
                                            </div>
                                        </div>
                                    </div>
                                </Nav>
                                <Nav style={{ paddingLeft: "1em" }}>
                                    <Button
                                        variant="link"
                                        onClick={this.logout}
                                        className={css(styles.buttonStyle)}
                                        title="Logout"
                                    >
                                        <img
                                            className={css(styles.imageiconsMenu)}
                                            alt="logout"
                                            src="/images/login.png"
                                        />
                                    </Button>
                                </Nav>
                            </div>
                        </Container>
                    </Navbar>
                </div>
            </div>
            // <Navbar className={`${css(styles.header)} ${css(styles.menu)}`}>
            //     <Container fluid>
            //     <Navbar.Brand>
            //     <Button className={css(styles.toggleStyle)} variant="link" active={this.props.isOpen} onClick={this.props.toggle}>
            //          <FontAwesomeIcon icon={faBars} />
            //     </Button>
            //     <img alt="logo" src="images/login-logo.png" style={{ width: "250px" }} />
            //     </Navbar.Brand>
            //     <Nav className="justify-content-end">
            //     <Nav.Link href="/dashboard" className={css(styles.navLink)}>
            //         <img className={css(styles.imageiconsMenu)} alt="home" src="images/home.png" />
            //     </Nav.Link>
            //     <Nav.Link href="/dashboard" className={css(styles.navLink)}>
            //         <img className={css(styles.imageiconsMenu)} alt="building" src="images/building.png" />
            //     </Nav.Link>
            //     <Nav.Link href="/dashboard" className={css(styles.navLink)}>
            //         <img className={css(styles.imageiconsMenu)} alt="suitcase" src="images/suitcase.png" />
            //     </Nav.Link>
            //     <Nav.Link href="/dashboard" className={css(styles.navLink)}>
            //         <img className={css(styles.imageiconsMenu)} alt="searchbox" src="images/searchbox.png" />
            //     </Nav.Link>
            //     <Nav.Link href="/dashboard" className={css(styles.navLink)}>
            //         <img className={css(styles.imageiconsMenu)} alt="userGroup" src="images/userGroup.png" />
            //     </Nav.Link>
            //     <Nav.Link href="/dashboard" className={css(styles.navLink)}>
            //         <img className={css(styles.imageiconsMenu)} alt="userGear" src="images/userGear.png" />
            //     </Nav.Link>
            //     <Nav.Link href="/dashboard" className={css(styles.navLink)}>
            //         <img className={css(styles.imageiconsMenu)} alt="graph" src="images/graph.png" />
            //     </Nav.Link>
            //     <NavDropdown title={<img className={css(styles.imageiconsMenu)} alt="gear" src="images/gear.png" />}>
            //         <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
            //         <NavDropdown.Item href="#action4">Another action</NavDropdown.Item>
            //         <NavDropdown.Divider />
            //         <NavDropdown.Item href="#action5">
            //             Something else here
            //         </NavDropdown.Item>
            //     </NavDropdown>
            //     <Nav.Link href="/dashboard" className={css(styles.navLink)}>
            //         <img className={css(styles.imageiconsMenu)} alt="help" src="images/help_outline.png" />
            //     </Nav.Link>
            //     </Nav>
            //     <div style={{display: "flex", alignItems: "center"}}>
            //         <img
            //             alt="avatar"
            //             src="images/user-flat.png"
            //             className={css(styles.avatar)}
            //         />
            //         <div className={css(styles.name)}>
            //             {/* this.props.user.username ? this.props.user.username : "" */}
            //             {"Nitin Dubey"}

            //             <div className={css(styles.last)}>
            //             Last login:{" "}
            //             {moment(1646737257000).format(
            //                     "MMM Do, YYYY, h:mm A"
            //                 )}
            //             </div>
            //         </div>
            //         <Button
            //             variant="link"
            //             //onClick={this.props.toggle}
            //             className={css(styles.buttonStyle)}
            //         >
            //             <img
            //                 className={css(styles.imageiconsMenu)}
            //                 alt="logout"
            //                 src="images/login.png"
            //             />
            //         </Button>
            //     </div>
            //     </Container>
            // </Navbar>

            //   <Menu size={"small"} className={`Container-fluid ${css(styles.header)} ${css(styles.menu)}`}>
            //     <div class="row" style={{margin: "0px"}}>
            //     <div className="col-lg-3" style={{'display':'flex'}}>
            //      <Menu.Item header className={css(styles.menuItem)} style={{margin: "19px"}}>
            //         <Button toggle active={this.props.isOpen} onClick={this.props.toggle} className={css(styles.button)}>
            //             <FontAwesomeIcon icon={faBars} />
            //         </Button>
            //       </Menu.Item>
            //       <Menu.Item header className={css(styles.menuItem, styles.logo)}>
            //         <img alt="logo" src="images/login-logo.png" style={{ width: "235px" }} />
            //       </Menu.Item>
            //     </div>
            //     <div className="col-lg-9" style={{'display':'flex'}}>
            //       <Menu.Item
            //         className={css(styles.menuItem, styles.itensMenu, styles.w100)}
            //         position={"right"}
            //       >
            //         <div className={css(styles.userHeader)}>
            //             <div className={css(styles.imageUser)}>
            //             <img
            //                 alt="avatar"
            //                 src="images/user-flat.png"
            //                 className={css(styles.avatar)}
            //             />
            //             <div className={css(styles.name)}>
            //                 {/* this.props.user.username ? this.props.user.username : "" */}
            //                 {"Nitin Dubey"}

            //                 <div className={css(styles.last)}>
            //                 Last login:{" "}
            //                 {moment(1646737257000).format(
            //                         "MMM Do, YYYY, h:mm A"
            //                     )}
            //                 </div>
            //             </div>
            //             <div className={css(styles.buttonLogout)}>
            //                 <a href="/dashboard" title="Logout">
            //                 <img
            //                     className={css(styles.imageiconsMenu)}
            //                     alt="logout"
            //                     src="images/login.png"
            //                 />
            //                 </a>
            //             </div>
            //             </div>
            //             <div className={css(styles.divIcons)}>
            //             <a
            //                 href="/dashboard"
            //                 className={css(styles.iconsMenu)}
            //                 title="Home">
            //                 <img
            //                 className={css(
            //                     styles.imageiconsMenu,
            //                     styles.menuActive
            //                 )}
            //                 alt="home"
            //                 src="images/home.png"
            //                 />
            //             </a>

            //             <a
            //                 href="/dashboard"
            //                 className={css(styles.iconsMenu)}
            //                 title="Patients">
            //                 <img
            //                     className={css(
            //                     styles.imageiconsMenu,
            //                     )}
            //                     alt="patients"
            //                     src="images/building.png"
            //                 />
            //             </a>

            //             <a
            //                 href="/dashboard"
            //                 className={css(styles.iconsMenu)}
            //                 title="Patients">
            //                 <img
            //                     className={css(
            //                     styles.imageiconsMenu,
            //                     )}
            //                     alt="patients"
            //                     src="images/suitcase.png"
            //                 />
            //             </a>

            //             <a
            //                 href="/dashboard"
            //                 className={css(styles.iconsMenu)}
            //                 title="Patients">
            //                 <img
            //                     className={css(
            //                     styles.imageiconsMenu,
            //                     )}
            //                     alt="patients"
            //                     src="images/searchbox.png"
            //                 />
            //             </a>

            //             <a
            //                 href="/dashboard"
            //                 className={css(styles.iconsMenu)}
            //                 title="Patients">
            //                 <img
            //                     className={css(
            //                     styles.imageiconsMenu,
            //                     )}
            //                     alt="patients"
            //                     src="images/userGroup.png"
            //                 />
            //             </a>

            //             <a  href="/dashboard"
            //                 className={css(styles.iconsMenu)}
            //                 title="Patients">
            //                 <img
            //                     className={css(
            //                     styles.imageiconsMenu,
            //                     )}
            //                     alt="patients"
            //                     src="images/userGear.png"
            //                 />
            //             </a>

            //             <a  href="/dashboard"
            //                 className={css(styles.iconsMenu)}
            //                 title="Patients">
            //                 <img
            //                     className={css(
            //                     styles.imageiconsMenu,
            //                     )}
            //                     alt="patients"
            //                     src="images/graph.png"
            //                 />
            //             </a>

            //                 {/* <Dropdown
            //                 icon={
            //                     <img
            //                     className={css(
            //                         styles.imageiconsMenu,
            //                         styles.iconsMenu,
            //                     )}
            //                     alt="reports"
            //                     src="images/suitcase.png"
            //                     />
            //                 }
            //                 //className="icon"
            //                 floating
            //                 inline>
            //                 <Dropdown.Menu className={css(styles.dropdownMenu)}>

            //                     {
            //                         <Dropdown.Item
            //                         className={css(styles.dropdownItem)}
            //                         onClick={this.goToDiseaseManagementReports}
            //                         >
            //                         DISEASE STATE MANAGEMENT
            //                         </Dropdown.Item>
            //                     }
            //                 </Dropdown.Menu>
            //                 </Dropdown> */}

            //             <span className={css(styles.barWhite)} />
            //             <div className={css(styles.divClientRelative)}>

            //                 <a  href="/dashboard"
            //                     className={css(styles.iconsMenu)}
            //                     title="Settings">
            //                     <img
            //                     className={css(
            //                         styles.imageiconsMenu,
            //                     )}
            //                     alt="settings"
            //                     src="images/gear.png"
            //                     />
            //                 </a>

            //                 <a  href="/dashboard"
            //                     className={css(styles.iconsMenu)}
            //                     title="Settings">
            //                     <img
            //                     className={css(
            //                         styles.imageiconsMenu,
            //                     )}
            //                     alt="settings"
            //                     src="images/help_outline.png"
            //                     />
            //                 </a>
            //             </div>
            //             </div>
            //         </div>
            //       </Menu.Item>
            //     </div>
            //     </div>
            //   </Menu>
        );
    }
}

export default connect(
    (store) => {
        return {
            menuExpanded: store.menuExpanded,
            user: store.user,
            profileData: store.appstate.profileData,
            patientSubscription: store.appstate.patientSubscription,
        };
    },
    (dispatch) => {
        return {
            changeNavigationState: () => {
                dispatch({ type: "EXPAND_REDUCE_MENU" });
            },
        };
    }
)(withRouter(Header));
